
import * as React from "react";
import "./FollowUsBox.scss";
import { ClassableProps, baseClassAnd, childClassClosure } from "@jcharlesworthuk/your-mum-core/dist/functions";
import { ISocialPage } from "../../models";
import { OutboundHyperlinkProps } from "../../pluggables";
import SocialButton from "../social/SocialButton";

const baseClass = 'follow-us-box';
const childClass = childClassClosure(baseClass);

type Props = ClassableProps & {
    pages: ISocialPage[];
    /**
     * Pass in the component you use for outbound links.  eg. OutboundLink (Gatsby GA) or just <a>
     */
    linkComponent: React.ComponentClass<OutboundHyperlinkProps, {}>;
};

const FollowUsBox: React.FunctionComponent<Props> = (props: Props) => {
    return <div className={baseClassAnd(baseClass, props)}>
        <h4 className={childClass('title')}>Follow Us</h4>
        <ul className={childClass('icon-list')}>
            {props.pages.map(page => <li key={page.name}>
                <SocialButton linkComponent={props.linkComponent} page={page} /></li>)
            }
        </ul>
    </div>
}
export default FollowUsBox;